import { Toggle } from "@faire/slate/components/toggle";

import { COPY } from "../copy";

import { BudgetLimitingTag } from "./BudgetLimitingTag";

type ProductBoostingCardProps = {
  newProductsBoosting: boolean;
  onNewProductsBoostingChange: (value: boolean) => void;
  budgetConstrained?: boolean;
};

export function ProductBoostingCard({
  newProductsBoosting,
  onNewProductsBoostingChange,
  budgetConstrained = false,
}: ProductBoostingCardProps) {
  return (
    <section className="bg-fs-surface-primary rounded-lg border border-[#dfe0e1] p-6">
      <div className="flex items-start justify-between gap-4">
        <div className="min-w-0">
          <h3 className="text-[20px] leading-[28px] font-medium text-[#333]">
            New product boosting
          </h3>
          <p className="mt-1 max-w-[600px] text-sm leading-5 text-[#757575]">
            Increase visibility for products you&apos;ve added in the last 60
            days. We&apos;ll spend your budget more aggressively to jump start
            their performance on the marketplace, which may result in a higher
            average cost per click.{" "}
            <button type="button" className="underline">
              Learn more
            </button>
          </p>
        </div>
        <div className="flex shrink-0 items-center gap-2">
          <Toggle
            checked={newProductsBoosting}
            onChange={(e) => onNewProductsBoostingChange(e.target.checked)}
            aria-label="New product boosting"
          />
          <span className="text-sm leading-5 text-[#333]">
            {newProductsBoosting ? "On" : "Off"}
          </span>
        </div>
      </div>
      {budgetConstrained && newProductsBoosting ? (
        <div className="mt-4">
          <BudgetLimitingTag tooltip={COPY.settings.productBoosting} />
        </div>
      ) : null}
    </section>
  );
}
